export default class AnalyticsService {

    private static instance: AnalyticsService;

    private constructor() {
    }

    public static getInstance(): AnalyticsService {
        if (!AnalyticsService.instance) {
            AnalyticsService.instance = new AnalyticsService();
        }
        return AnalyticsService.instance;
    }

    public logMapSelectFilter(filter: string): void {
        this.log('map_select_filter', {'filter': filter});
    }

    public logMapSearchTerm(term: string): void {
        this.log('map_search_term', {'search_term': term});
    }

    private log(event: string, params: { [name: string]: string | number | boolean }): void {
        const dataLayer: any[] = (window as any).dataLayer || [];
        dataLayer.push({'event': event, ...params});
    }
}
